import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import contactTransEn from "./locales/en/contact.json";
import contactTransAr from "./locales/ar/contact.json";

import footerEn from "./locales/en/footer.json";
import footerAr from "./locales/ar/footer.json";

import headerTransEn from "./locales/en/header.json";
import headerTransAr from "./locales/ar/header.json";

import homePageEn from "./locales/en/homepage.json";
import homePageAr from "./locales/ar/homepage.json";

import loginPageEn from "./locales/en/login.json";
import loginPageAr from "./locales/ar/login.json";

import mapPageEn from "./locales/en/map.json";
import mapPageAr from "./locales/ar/map.json";
import issueInboxPageEn from "./locales/en/IssueInbox.json";
import issueInboxPageAr from "./locales/ar/IssueInbox.json";

import ShareAddressEn from "./locales/en/ShareAddress.json";
import ShareAddressAr from "./locales/ar/ShareAddress.json";

import reportIssuePageEN from "./locales/en/reportissue.json";
import reportIssuePageAr from "./locales/ar/reportissue.json";

import timeOutPageEN from "./locales/en/timeout.json";
import timeOutPageAr from "./locales/ar/timeout.json";

import uaePassPageEN from "./locales/en/uaepasspage.json";
import uaePassPageAr from "./locales/ar/uaepasspage.json";

import ShareAddressComponentEn from "./locales/en/ShareAddressComponent.json";
import ShareAddressComponentAr from "./locales/ar/ShareAddressComponent.json";


const resources = {
  en: {
    contact: contactTransEn,
    header: headerTransEn,
    homepage: homePageEn,
    footer: footerEn,
    loginPage: loginPageEn,
    mapPage: mapPageEn,
    reportIssuePage: reportIssuePageEN,
    ShareAddress: ShareAddressEn,
    issueInboxPage: issueInboxPageEn,
    timeOutPage: timeOutPageEN,
    uaePassPage: uaePassPageEN,
    ShareAddressComponent : ShareAddressComponentEn
  },
  ar: {
    contact: contactTransAr,
    header: headerTransAr,
    homepage: homePageAr,
    footer: footerAr,
    loginPage: loginPageAr,
    mapPage: mapPageAr,
    reportIssuePage: reportIssuePageAr,
    ShareAddress: ShareAddressAr,
    issueInboxPage: issueInboxPageAr,
    timeOutPage: timeOutPageAr,
    uaePassPage: uaePassPageAr,
    ShareAddressComponent : ShareAddressComponentAr
  },
};
i18n
  .use(Backend)
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // backend :{loadPath : '/locales/'
    resources,
    defaultNS: "contact",
    fallbackLng: "ar",
    debug: true,
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: false,
    },
  });

// const changeLanguage = (lng:string) => {
//     i18n.changeLanguage(lng);
// };

export default i18n;
